module.exports = __webpack_public_path__ + "images/avatars/male/4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/4.png
// module id = brzu
// module chunks = 118